// import React from 'react';
// import { createRoot } from 'react-dom/client';
// import App from './App';
// import { BrowserRouter } from 'react-router-dom';

// const container = document.getElementById('root');
// const root = createRoot(container); // Create root

// root.render(
//   <BrowserRouter>
//     <App />
//   </BrowserRouter>
// );




import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './AuthContext'; // Adjust the path as needed

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);


